require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./equipes-de-la-vpfi-1-1-2-1.json") })
        }
      }, "path---equipes-de-la-vpfi-1-1-2-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---equipes-de-la-vpfi-1-1-2-1!./.cache/json/equipes-de-la-vpfi-1-1-2-1.json
// module id = 422
// module chunks = 231608221292675